// extracted by mini-css-extract-plugin
export default {"iconButton":"icon-button_iconButton__YDn7i","img":"icon-button_img__67nV9","sidMenuOpenIcon":"icon-button_sidMenuOpenIcon__ZGAKi"};